module.exports = __webpack_public_path__ + "media/images/lp_which-be5c8799887aaff768fbac0d96fa2a55.webp";